'use strict';
import util from '../util';
import $ from 'jquery';
import Promise from 'bluebird';

/**
 * @return {Promise<jQuery>}
 */
$.fn.thenResetHeight = function() {
	return new Promise(resolve => {
		this.one(util.transitionDone(), () => {
			this.css('height', '');
			resolve(this);
		});
	});
}

/**
 * @param {jQuery} $el 
 * @param {Object} [options]
 * @param {String} [options.collapsedClass]
 * @return {Promise<jQuery>}
 */
export const slideDown = ($el, {collapsedClass = 'collapsed'} = {}) => {
	$el.addClass(collapsedClass).css('height', '');
	const $clone = $el.clone().removeClass(collapsedClass).insertAfter($el);
	const newHeight = $clone.outerHeight();
	$clone.remove();
	$el.css('height', newHeight);
	return $el.removeClass(collapsedClass).thenResetHeight();
}

/**
 * @param {jQuery} $el 
 * @param {Object} [options]
 * @param {String} [options.collapsedClass]
 * @return {Promise<jQuery>}
 */
export const slideUp = ($el, {collapsedClass = 'collapsed'} = {}) => {
	$el.css('height', $el.outerHeight());
	$el.css('height');
	return $el.addClass(collapsedClass).thenResetHeight();
}

export const slideToggle = ($el, {collapsedClass = 'collapsed'} = {}) => {
	return $el.hasClass(collapsedClass)
		? slideDown($el, collapsedClass)
		: slideUp($el, collapsedClass);
}
